<template>
  <vs-row>
    <b-loading :is-full-page="true" v-model="isLoading"/>
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      <vs-card style="border-radius: 10px;">
        <div class="columns">
          <div class="column">
            <CompanySelector v-model="company"/>
          </div>
          <div class="column">
            <b-field label="Nombre del horario">
              <b-input
                  placeholder="Ingrese un nombre para el horario..."
                  type="text"
                  v-model="schedule"
                  v-validate="'required'"
                  name="schedule"
              ></b-input>
            </b-field>
            <span class="show-error">{{ errors.first("schedule") }}</span>
          </div>
          <div class="column">
            <b-field label="Clasificación">
              <b-select
                  placeholder="Seleccione una Clasificación"
                  expanded
                  v-model="classification"
                  :value="classification"
                  v-validate="'required'"
                  name="classification"
              >
                <option
                    v-for="option in classifications"
                    :value="option.code"
                    :key="option.code"
                    :id="option.code"
                >
                  {{ option.title }}
                </option>
              </b-select>
            </b-field>
            <span class="show-error">{{ errors.first("classification") }}</span>
          </div>
          <div class="column">
            <b-field label="Id">
              <b-input
                  placeholder="Ingrese el id"
                  type="text"
                  v-model="idParkline"
                  v-validate="'required'"
                  name="idParkline"
              ></b-input>
            </b-field>
            <span class="show-error">{{ errors.first("idParkline") }}</span>
          </div>
        </div>
        <div class="d-flex">
          <vs-button
              icon="add"
              color="primary"
              @click="addScheduleFather()"
              v-if="selected == null">
            Añadir horario
          </vs-button>
          <vs-button color="dark" class="ml-2" type="filled" @click="clearForm()">
            Limpiar
          </vs-button>
        </div>


      </vs-card>

      <div>
        <vs-card style="border-radius: 10px;">
          <vs-table
              :data="fatherSchedules"
              v-model="selectedFather">
            <template slot="header">
              <h3>
                Lista de horarios
              </h3>
            </template>
            <template slot="thead">
              <vs-th sort-key="hour">Horario</vs-th>
              <vs-th sort-key="clasification">Clasificación</vs-th>
              <vs-th sort-key="identification">Id</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>
                <vs-td :data="data[indextr].classification">
                  {{ getClassificationName(data[indextr].classification) }}
                </vs-td>
                <vs-td :data="data[indextr].code">
                  {{ data[indextr].idParkline }}
                </vs-td>

              </vs-tr>
            </template>

          </vs-table>
        </vs-card>
      </div>
      <div>
        <vs-card style="border-radius: 10px;">
          <schedules-control
              ref="refSchedulesControl"
              v-bind:schedules=" selectedFather.schedules.filter((item) => !item.deleted)"
              @updateList="updateScheduleList"
              v-if="selectedFather"/>

          <div class="d-flex">
            <vs-button
                color="primary"
                @click="save()"
                v-if="selected == null">
              Guardar
            </vs-button>

            <vs-button
                v-if="selectedFather != null"
                @click="openDeleteModal()"
                color="danger"
                class="ml-2"
                icon-right="delete">
              eliminar
            </vs-button>
          </div>
        </vs-card>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import moment from "moment";
import {ROUTES} from "@/global/api_routes";
import CompanySelector from "../../components/Shared/CompanySelector";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {confirmation} from "@/global/utils";
import SchedulesControl from "./SchedulesControl/index.vue";
import {configToast, TOAST_TYPES} from "@/global/toast";
import DateUtils from "../../global/DateUtils";
import Styles from "./styles";
import CompanyEndpoint from "@/endpoints/core/CompanyEndpoint";
import toast from "@/global/ToastConfig";

export default {
  name: "CreateCompany",
  components: {CompanySelector, SchedulesControl, Styles},
  data: () => ({
    id: null,
    idParkline: null,
    company: null,
    schedule: null,
    day: null,
    initialHour: null,
    finalHour: null,
    selected: null,
    selectedFather: null,
    tableData: [],
    classification: null,
    classifications: [],
    days: [
      {name: "Lunes", id: 1},
      {name: "Martes", id: 2},
      {name: "Miercoles", id: 3},
      {name: "Jueves", id: 4},
      {name: "Viernes", id: 5},
      {name: "Sabado", id: 6},
      {name: "Domingo", id: 7},
      {name: "Festivo", id: 8},
      {name: "Especial", id: 9},
    ],
    schedules: {},
    fatherSchedules: [],
    companiesNoTree: [],
    isLoading: false,
  }),
  mounted() {
    this.getCompaniesNoTree();
    this.getClassifications();
  },
  watch: {
    schedule() {
      if (!this.selectedFather) {
        return;
      }
      this.selectedFather.name = this.schedule;
    },
    classification() {
      if (!this.selectedFather) {
        return;
      }
      this.selectedFather.classification = this.classification;
    },
    company() {
      if (!this.company) {
        this.fatherSchedules = [];
        return;
      }
      if (this.company) {
        this.getSchedules();
        return;
      }
      this.tableData = [];
      this.selected = null;
      this.company = null;
    },
    selected() {
      if (this.selected != null) {
        this.fillData(this.selected);
      }
    },
    selectedFather() {
      if (this.selectedFather != null) {
        const {timezone} = this;
        this.schedule = this.selectedFather.name;
        this.classification = this.selectedFather.classification;
        this.id = this.selectedFather.id;
        this.idParkline = this.selectedFather.idParkline;
      }
    },
  },
  methods: {
    clearForm() {
      this.company = null;
      this.selected = null;
      this.selectedFather = null;
      this.schedule = null;
      this.classification = null;
      this.idParkline = null;
      this.id = null;
      this.$validator.reset();
    },
    updateScheduleList(list) {
      const index = this.fatherSchedules.findIndex(
          (item) => item.code == this.selectedFather.code
      );
      if (index < 0) {
        console.log("RETURN");
        return;
      }

      this.selectedFather.schedules = list;
    },
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#schedules_container");
      return instance.open(message, type);
    },
    getClassificationName(classificationCode) {
      const classification = this.classifications.find(
          (c) => c.code === classificationCode
      );
      if (classification) {
        return classification.title;
      }
      return "No definido";
    },
    addScheduleFather() {
      const {company, schedule, classification, idParkline} = this;
      if (!company || company == null) {
        this.toast("Debe seleccionar la empresa", TOAST_TYPES.ERROR);
      }
      if (idParkline == null) {
        this.toast("Debe ingresar el id", TOAST_TYPES.ERROR);
        return;
      }
      if (schedule == null) {
        this.toast("Debe ingresar el nombre del horario", TOAST_TYPES.ERROR);
        return;
      }
      if (classification == null) {
        this.toast("Debes seleccionar una clasificación", TOAST_TYPES.ERROR);
        return;
      }
      const index = this.fatherSchedules.findIndex(
          (fsche) => fsche.name == this.schedule
      );
      if (index >= 0) {
        this.toast(
            "No puede tener 2 horarios con el mismo nombre",
            TOAST_TYPES.ERROR
        );
        return;
      }
      const newSchedule = {
        id : null,
        name: this.schedule,
        company: this.company,
        classification: this.classification,
        code: this.fatherSchedules.length + 1,
        idParkline: this.idParkline,
        schedules: [],
      };
      const newFatherSchedules = [...this.fatherSchedules, newSchedule];
      this.fatherSchedules = newFatherSchedules;
      this.selectedFather = newSchedule;
    },
    showNormalDate(date) {
      return DateUtils.toHourString({date, timezone: this.timezone});
    },
    showNormalDay(dayParam) {
      return this.days.find((day) => day.id == dayParam).name;
    },
    getNameCompany(companyId) {
      return this.companiesNoTree.find((company) => company.code == companyId)
          .name;
    },
    getNormalHours(schedule) {
      return schedule.schedules.map((item) => ({
        ...item,
        initialHour: this.showNormalDate(item.initialHour),
        finalHour: this.showNormalDate(item.finalHour),
      }));
    },
    save() {
      try {
        this.validateSave();
        console.log("los schedules  ===> ", this.fatherSchedules);
        const send = this.fatherSchedules.map((fsche) => {
          return {
            code: fsche.id ? fsche.id : null,
            company: {
              code: fsche.company,
            },
            title: fsche.name,
            scheduleDayList: this.getNormalHours(fsche),
            classification: fsche.classification,
            id: fsche.idParkline,
          };
        });
        send.forEach((s) => {
          if (s.code == null) {
            delete s.code;
          }
        });
        this.isLoading = true;
        this.$http
            .post(ROUTES.DASHBOARD.SCHEDULES.SAVE_SCHEDULE, send)
            .then(({data}) => {
              if (data.code > 0) {
                this.toast(data.message, TOAST_TYPES.SUCCESS);
                this.getSchedules();
                this.cleanForm();
                return;
              }
              this.isLoading = false;
              this.toast(data.message, TOAST_TYPES.ERROR);
            });
      } catch (ex) {
        toast.error(ex.message);
      }
    },

    validateSave() {
      if (!this.fatherSchedules || this.fatherSchedules.length === 0) {
        throw new Error("Debe agregar al menos un horario");
      }
      this.fatherSchedules.forEach(schedules => {

        console.log("===> ",schedules.name);
        const schedule = schedules.name;
        if (!schedules.name) {
          throw  new Error("Debe seleccionar una id del horario: " + schedule);
        }
        if (!schedules.idParkline) {
          throw  new Error("Debe seleccionar una id del horario: " + schedule);
        }
        if (!schedules.classification) {
          throw  new Error("Debe seleccionar una clasificación del horario: " + schedule);
        }
        if (!schedules.idParkline) {
          throw  new Error("Debe seleccionar una id del horario: " + schedule);
        }
        if ((!schedules.schedules || schedules.schedules.length === 0) && schedules.id === null) {
          throw  new Error("Debe seleccionar adicionar un rango al horario: " + schedule);
        }
      });
    },
    openDeleteModal() {
      confirmation(this, `¿Desea eliminar el horario?`).then((result) => {
        if (!result) {
          return;
        }
        this.deleteSchedule();
      });
    },
    deleteSchedule() {
      this.isLoading = true;
      this.$http
          .delete(ROUTES.DASHBOARD.SCHEDULES.DELETE_SCHEDULES, {
            data: {scheduleId: this.selectedFather.id},
          })
          .then(({data}) => {
            this.isLoading = false;
            if (data.code > 0) {
              this.toast(data.message, TOAST_TYPES.SUCCESS);
              this.getSchedules();
              this.selectedFather = null;
              return;
            }
            this.isLoading = false;
            this.toast(data.message, TOAST_TYPES.ERROR);
          });
    },
    parseSchedules(schedules) {
      const {timezone} = this;
      return schedules.map((item) => ({
        ...item,
        index: item.code,
        initialHour: DateUtils.parseHour({date: item.initialHour, timezone}),
        finalHour: DateUtils.parseHour({date: item.finalHour, timezone}),
      }));
    },
    getSchedules() {
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.SCHEDULES.GET_SCHEDULES, {
            params: {
              companyId: this.company,
              title: "",
            },
          })
          .then(({data}) => {
            if (data.code > 0) {
              this.fatherSchedules = data.info.map((fsche) => {
                return {
                  idParkline: fsche.id,
                  id: fsche.code,
                  code: fsche.code,
                  index: fsche.code,
                  name: fsche.title,
                  company: fsche.company.code,
                  schedules: this.parseSchedules(fsche.scheduleDayList),
                  classification: fsche.classification,
                };
              });
              this.selectedFather = null;
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    cleanForm() {
      this.idParkline = null;
      this.id = null;
      this.schedule = null;
      this.day = null;
      this.initialHour = null;
      this.finalHour = null;
      this.selected = null;
      this.classification = null;
    },
    fillData(selected) {
      if (
          selected.initialHour instanceof Date ||
          selected.finalDate instanceof Date
      ) {
        if (selected.initialHour instanceof Date) {
          this.initialHour = selected.initialHour;
          this.day = selected.day;
        }
        if (selected.finalHour instanceof Date) {
          this.finalHour = selected.finalHour;
          this.day = selected.day;
        }
        return;
      }
      const initialDate = `${moment().format("YYYY-MM-DD")} ${
          selected.initialHour
      }`;
      const finalDate = `${moment().format("YYYY-MM-DD")} ${
          selected.initialHour
      }`;
      this.initialHour = moment(initialDate).toDate();
      this.finalHour = moment(finalDate).toDate();
      this.day = selected.day;
    },
    cleanUpChildren() {
      this.selected = null;
      this.initialHour = null;
      this.day = null;
      this.finalHour = null;
    },
    getClassifications() {
      this.$http
          .get(ROUTES.DASHBOARD.SCHEDULES.GET_SCHEDULE_CLASSIFICATION)
          .then(({data}) => {
            if (data.code > 0) {
              this.classifications = data.info;
            }
          });
    },
    getCompaniesNoTree() {
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.GET_SAVED_COMPANIES, {
            params: {
              criteria: "",
            },
          })
          .then(({data}) => {
            if (data.code > 0) {
              this.isLoading = false;
              this.companiesNoTree = data.info;
              return;
            }
            this.isLoading = false;
            this.toast(data.message, TOAST_TYPES.ERROR);
          });
    },
  },
};
</script>
